document.addEventListener('DOMContentLoaded', function () {
  const displayCarouselBtns = (buttons, carousel) => {
    const scrollMax = carousel.scrollWidth - carousel.offsetWidth;
    if (carousel.scrollLeft < 20) {
      changeButtonState(buttons[0], false);
    } else {
      changeButtonState(buttons[0], true);
    }
    if (carousel.scrollLeft > (scrollMax - 20)) {
      changeButtonState(buttons[1], false);
    } else {
      changeButtonState(buttons[1], true);
    }
  }

  document.querySelectorAll('.custom-carousel').forEach(function (el) {
    const carouselButtons = el.querySelectorAll('.custom-carousel__button');
    const carousel = el.querySelector('.custom-carousel__wrapper');

    const getFirstCarouselItemWidth = () => {
      const firstCarouselItem = carousel.querySelector('.custom-featured-product');
      return firstCarouselItem.offsetWidth;
    }

    carouselButtons.forEach(button => {
      button.addEventListener('click', function () {
        let firstCarouselItemWidth = getFirstCarouselItemWidth();
        if (this.classList.contains('custom-carousel__button--left')) {
          firstCarouselItemWidth *= -1
        }
        carousel.scrollBy(firstCarouselItemWidth, 0);
        displayCarouselBtns(carouselButtons, carousel);
      });
    });

    carousel.parentElement.addEventListener('mouseenter', () => {
      displayCarouselBtns(carouselButtons, carousel);
    });

    carousel.parentElement.addEventListener('mouseleave', () => {
      carouselButtons.forEach((btn) => btn.classList.remove('active'));
    });

    carousel.addEventListener('scroll', () => {
      displayCarouselBtns(carouselButtons, carousel);
    });


    [...carousel.children].forEach(item => {
      // scroll parent on drag
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const startX = e.clientX;
        const scrollLeft = carousel.scrollLeft;
        carousel.classList.add('grabbing');

        const mouseMove = (e) => {
          e.preventDefault();
          const x = e.clientX;
          const walk = (x - startX) * 2;
          carousel.scrollLeft = scrollLeft - walk;
        }

        const mouseUp = (e) => {
          if (e.clientX === startX) {
            const link = item.querySelector('a');
            if (link) {
              link.click();
            }
          }

          document.removeEventListener('mousemove', mouseMove);
          document.removeEventListener('mouseup', mouseUp);
          document.removeEventListener('mouseleave', mouseUp);
          carousel.classList.remove('grabbing');
        }

        document.addEventListener('mousemove', mouseMove);
        document.addEventListener('mouseup', mouseUp);
        document.addEventListener('mouseleave', mouseUp);
      });
    });
  });
});

function changeButtonState(button, state) {
  if (state) return button.classList.add('active');
  button.classList.remove('active');
}
